import {
    GET_PERSON_REVENUES_REQUEST,
    GET_PERSON_REVENUES_SUCCESS,
    GET_PERSON_REVENUES_FAILURE,
    GET_PERSON_TARGETS_REQUEST,
    GET_PERSON_TARGETS_SUCCESS,
    GET_PERSON_TARGET_FAILURE,
    DELETE_PERSON_TARGET_REQUEST,
    DELETE_PERSON_TARGET_SUCCESS,
    DELETE_PERSON_TARGET_FAILURE,
    UPDATE_PERSON_TARGET_REQUEST,
    UPDATE_PERSON_TARGET_SUCCESS,
    UPDATE_PERSON_TARGET_FAILURE,
    CREATE_PERSON_TARGET_REQUEST,
    CREATE_PERSON_TARGET_SUCCESS,
    CREATE_PERSON_TARGET_FAILURE
} from './ActionTypes'
import Client from '../Client/Client'
import {Moment} from 'moment'
import ITargetState from './ITargetState'
import {IPersonRevenue, ITarget} from '../Client/ITarget'
import {AxiosError} from 'axios'
import { ThunkDispatch } from '@reduxjs/toolkit'

export const getPersonRevenues = (startDate: Moment, endDate: Moment) => {
    return (dispatch: ThunkDispatch<ITargetState, undefined, any>) => {
        dispatch(
            {
                type: GET_PERSON_REVENUES_REQUEST
            }
        )

        return Client
            .getPersonRevenues(startDate, endDate)
            .then(
                (personRevenues) => {
                    dispatch(getPersonRevenuesSuccess(personRevenues))
                },
                () => dispatch(getPersonRevenuesFailure())
            )
    }
}

export const getPersonRevenuesSuccess = (personRevenues: IPersonRevenue[]) => {
    return {
        type: GET_PERSON_REVENUES_SUCCESS,
        payload: {
            personRevenues
        }
    }
}

export const getPersonRevenuesFailure = () => {
    return {
        type: GET_PERSON_REVENUES_FAILURE,
    }
}

export const getPersonTargets = () => {
    return (dispatch: ThunkDispatch<ITargetState, undefined, any>) => {
        dispatch(
            {
                type: GET_PERSON_TARGETS_REQUEST
            }
        )

        return Client
            .getPersonTargets()
            .then(
                (personTargets) => {
                    dispatch(getPersonTargetsSuccess(personTargets))
                },
                () => dispatch(getPersonTargetsFailure())
            )
    }
}

export const getPersonTargetsSuccess = (personTargets: ITarget[]) => {
    return {
        type: GET_PERSON_TARGETS_SUCCESS,
        payload: {
            personTargets
        }
    }
}

export const getPersonTargetsFailure = () => {
    return {
        type: GET_PERSON_TARGET_FAILURE
    }
}

export const deletePersonTarget = (personTarget: ITarget) => {
    return (dispatch: ThunkDispatch<ITargetState, undefined, any>) => {
        dispatch(
            {
                type: DELETE_PERSON_TARGET_REQUEST,
            }
        )

        return Client
            .deletePersonTarget(personTarget)
            .then(
                (personTarget) => {
                    dispatch(setDeletePersonTargetSuccess(personTarget))
                }
                ,
                () => dispatch(setDeletePersonTargetFailure())
            )
    }
}


export const setDeletePersonTargetSuccess = (personTarget: ITarget) => {
    return {
        type: DELETE_PERSON_TARGET_SUCCESS,
        payload: {
            personTarget
        }
    }
}

export const setDeletePersonTargetFailure = () => {
    return {
        type: DELETE_PERSON_TARGET_FAILURE
    }
}

export const createPersonTarget = (personTarget: ITarget) => {
    return (dispatch: ThunkDispatch<ITargetState, undefined, any>) => {
        dispatch(
            {
                type: CREATE_PERSON_TARGET_REQUEST,
            }
        )

        return Client
            .createPersonTarget(personTarget)
            .then(
                (personTarget) => {
                    dispatch(createPersonTargetSuccess(personTarget))
                }
            )
            .catch((error: AxiosError) => {
                dispatch(createPersonTargetFailure(error.response.data))

                throw new Error()
            })
    }
}

export const createPersonTargetSuccess = (personTarget: ITarget) => {
    return (dispatch: ThunkDispatch<ITargetState, undefined, any>) => {
        dispatch(
            {
                type: CREATE_PERSON_TARGET_SUCCESS,
                payload: {
                    personTarget
                }
            }
        )
    }
}

const createPersonTargetFailure = (errors: Array<any>) => {
    return {
        type: CREATE_PERSON_TARGET_FAILURE,
        errors
    }
}

export const updatePersonTarget = (personTarget: ITarget) => {
    return (dispatch: ThunkDispatch<ITargetState, undefined, any>) => {
        dispatch(
            {
                type: UPDATE_PERSON_TARGET_REQUEST,
            }
        )

        return Client
            .updatePersonTarget(personTarget)
            .then(
                ([oldPersonTarget, newPersonTarget]) => {
                    dispatch(updatePersonTargetSuccess(oldPersonTarget, newPersonTarget))
                }
            )
            .catch((error: AxiosError) => {
                dispatch(updatePersonTargetFailure(error.response.data))

                throw new Error()
            })
    }
}

export const updatePersonTargetSuccess = (oldPersonTarget: ITarget, newPersonTarget: ITarget) => {
    return (dispatch: ThunkDispatch<ITargetState, undefined, any>) => {
        dispatch(
            {
                type: UPDATE_PERSON_TARGET_SUCCESS,
                payload: {
                    oldPersonTarget,
                    newPersonTarget
                }
            }
        )
    }
}

const updatePersonTargetFailure = (errors: Array<any>) => {
    return {
        type: UPDATE_PERSON_TARGET_FAILURE,
        errors
    }
}
